import { Component, Input, inject } from '@angular/core';
import { ConditionsConfirmationGenerationStatus } from '../../../models/enums/conditions-confirmation-generation-status';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../shared/messages/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-conditions-confirmation-dialog-message',
  templateUrl: './conditions-confirmation-dialog-message.component.html',
  styleUrl: './conditions-confirmation-dialog-message.component.scss',
  standalone: false
})
export class ConditionsConfirmationDialogMessageComponent {
  dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
  data = inject<{
    selectedWorkerAgreements: number;
    response: {
      [key: number]: ConditionsConfirmationGenerationStatus;
    };
  }>(MAT_DIALOG_DATA);

  @Input() selectedWorkerAgreements: number;
  @Input() response: { [key: number]: ConditionsConfirmationGenerationStatus };


  constructor() {
    const data = this.data;

    this.selectedWorkerAgreements = data.selectedWorkerAgreements;
    this.response = data.response;
  }

  public ConditionsConfirmationGenerationStatus = ConditionsConfirmationGenerationStatus;

  get resultCounts() {
    const counts = {
      [ConditionsConfirmationGenerationStatus.ReadyToGenerate]: 0,
      [ConditionsConfirmationGenerationStatus.AlreadyGenerated]: 0,
      [ConditionsConfirmationGenerationStatus.CannotGenerateForMandateAgreement]: 0,
      [ConditionsConfirmationGenerationStatus.CannotGenerateForImportedFromOtherSystems]: 0,
      [ConditionsConfirmationGenerationStatus.CannotGenerateForNotSignByUser]: 0,
    };

    Object.values(this.response).forEach(status => {
      if (counts.hasOwnProperty(status)) {
        counts[status]++;
      }
    });

    return counts;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}
